<template>
	<div class="my-1 summary-order-grid fontS14" v-if="orderSummaryInfo">
		<div>
			<location-svg class="address-summary" primary/>
		</div>
		<div class="line-height-2 d-flex flex-column" v-if="isDelivered">
			<h4 class="my-0 fontAvenirBold">{{orderSummaryInfo.pickUpName}}</h4>
			<span class="fontS13 fontOpenBold">{{orderSummaryInfo.responsiblePickUp.name}}</span>
			<span class="fontS13">DNI: <span class="fontOpenBold">{{orderSummaryInfo.responsiblePickUp.dni}}</span></span>
			<span class="fontS13">Teléfono: <span class="fontOpenBold">{{orderSummaryInfo.responsiblePickUp.phone}}</span></span>
			<span class="fontS13">Dirección: <span class="fontOpenBold">{{orderSummaryInfo.customerAddress.name}} - {{orderSummaryInfo.customerAddress.addressLine1}}</span></span>
		</div>
		<div class="line-height-2 d-flex flex-column" v-else>
			<h4 class="my-0 fontAvenirBold">{{orderSummaryInfo.pickUpName}}</h4>
			<span>Tienda: {{orderSummaryInfo.warehouseName}}</span>
			<span>Dirección: {{orderSummaryInfo.warehouseAddress}}</span>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function isDelivered() {
	return this.flagPickUp === 1;
}

export default {
	name: 'address-data',
	components: {
		locationSvg: () => import('@/components/svg-components/locationSvg'),
	},
	computed: {
		...mapGetters([
			'flagPickUp',
			'orderSummaryInfo',
		]),
		isDelivered,
	},
};
</script>
<style lang="scss" scoped>
	.address-summary .in-active-svg {
		fill: color(defaultOrange) !important;
	}
</style>



// WEBPACK FOOTER //
// addressData.vue?fd01b2e8